/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".actions[_ngcontent-%COMP%]{align-content:center;align-items:center;-ms-grid-row-align:center;align-self:center}"];
export { styles as styles };
